<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   class="bread">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品图片管理</el-breadcrumb-item>
      <el-breadcrumb-item>图片信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!--搜索栏区域-->
    <el-row :gutter="20"
            class="search">
      <el-col :span="11">
        <el-select v-model="shopId"
                   placeholder="请选择商品Id">
          <el-option v-for="item in productId"
                     :key="item.id"
                     :label="item.productId"
                     :value="item.id"></el-option>
        </el-select>
        <el-button icon="el-icon-search"
                   @click="searchList">搜索
        </el-button>
      </el-col>
    </el-row>
    <el-button class="add-btn"
               @click="addImg"
               type="primary"
               icon="el-icon-circle-plus">新增图片
    </el-button>

    <el-button type="warning" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button>
    <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="date" label="日期" width="150"></el-table-column>
        <el-table-column property="name" label="姓名" width="200"></el-table-column>
        <el-table-column property="address" label="地址"></el-table-column>
      </el-table>
    </el-dialog>
    <el-button type="primary" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button>

    <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="活动名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动区域" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-table stripe
              border>
      <el-table-column prop="id"
                       label="图片编号"
                       align="center"></el-table-column>
      <el-table-column prop="imgAddr"
                       label="图片地址"
                       align="center"></el-table-column>
      <el-table-column prop="imgDesc"
                       label="图片介绍"
                       align="center"></el-table-column>
      <el-table-column label="操作" width="200px" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="editImg(scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteImg(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  const request = require('../../http/photo')
  export default {
    name: 'imgList',
    mounted () {
      this.getImgList()
    },
    data () {
      return {
        productId: [], // 商品编号
        gridData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        dialogTableVisible: false,
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px'
      }
    },
    methods: {
      handleSizeChange (size) { // pageSize改变时触发
        this.pageSize = size
      },
      handleCurrentPage (currentPage) { // 当前页面改变时触发
        this.currentPage = currentPage
      },
      async deleteImg (row) { // 删除地址
        let data = {
          id: row.id
        }
        let deleteImgRes = await request.deleteImg(data)
        if (deleteImgRes.data.message === '成功') {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        } else {
          this.$message.error('删除失败')
        }
        await this.getImgList()
      },
      addImg () { // 跳转到新增地址页
        this.$router.push('/addImg')
      }
    }
  }
</script>

<style scoped>
  .add-btn {
    margin-top: 10px;
  }
</style>
